<template>
  <div id="wrap" class="satisfaction">
    <div class="satisfaction_header">
      <h1><img src="@/assets/image/satisfy/ci-kolon-benit.png" alt="KOLON BENIT"></h1>
      <p>현재 접속하신 <strong>{{ systemNm }}</strong>에 대한<br>사용자 여러분의 <strong>체감 만족도</strong>를 조사합니다.</p>
    </div>
    <div class="satisfaction_cont">
      <span class="title_q">"{{ researchPeriod }}와 비교해, 본 시스템과 서비스는 좋아졌나요?"</span>
      <span style="color: #7d7d7d;font-size: 24px; line-height: 26px; letter-spacing: -1.0px; text-align: center; display: block; padding: 10px 24px 0px 24px;">
        응답하신 결과는 익명으로 처리되며, <br>시스템 개선 목적으로만 활용됩니다.
      </span>

      <div class="checks">
        <span>
          <input id="satisfaction01" type="radio" name="satisfaction" value="3" v-model="answer01">
          <label class="satisfaction01" for="satisfaction01">좋아짐<span>좋아짐</span></label>
        </span>
        <span>
          <input id="satisfaction02" type="radio" name="satisfaction" value="2" v-model="answer01">
          <label class="satisfaction02" for="satisfaction02">비슷함<span>비슷함</span></label>
        </span>
        <span>
          <input id="satisfaction03" type="radio" name="satisfaction" value="1" v-model="answer01">
          <label class="satisfaction03" for="satisfaction03">나빠짐<span>나빠짐</span></label>
        </span>
      </div>
      <hr>
      <span class="title_q">이 시스템에 대한 상세한 평가를 해 주세요.</span>
      <dl>
        <dt>시스템 오류빈도</dt>
        <dd class="first_dd">
          <input id="satisfaction_01_01" type="radio" name="satisfaction01" value="3" v-model="answer02">
          <label class="satisfaction_01_01" for="satisfaction_01_01"><span>줄어듬</span>줄어듬</label>
        </dd>
        <dd>
          <input id="satisfaction_01_02" type="radio" name="satisfaction01" value="2" v-model="answer02">
          <label class="satisfaction_01_02" for="satisfaction_01_02"><span>비슷함</span>비슷함</label>
        </dd>
        <dd>
          <input id="satisfaction_01_03" type="radio" name="satisfaction01" value="1" v-model="answer02">
          <label class="satisfaction_01_03" for="satisfaction_01_03"><span>늘어남</span>늘어남</label>
        </dd>
      </dl>
      <dl>
        <dt>시스템 속도</dt>
        <dd class="first_dd">
          <input id="satisfaction_02_01" type="radio" name="satisfaction02" value="3" v-model="answer03">
          <label class="satisfaction_02_01" for="satisfaction_02_01"><span>빨라짐</span>빨라짐</label>
        </dd>
        <dd>
          <input id="satisfaction_02_02" type="radio" name="satisfaction02" value="2" v-model="answer03">
          <label class="satisfaction_02_02" for="satisfaction_02_02"><span>비슷함</span>비슷함</label>
        </dd>
        <dd>
          <input id="satisfaction_02_03" type="radio" name="satisfaction02" value="1" v-model="answer03">
          <label class="satisfaction_02_03" for="satisfaction_02_03"><span>느려짐</span>느려짐</label>
        </dd>
      </dl>
      <dl>
        <dt>서비스담당자 응대</dt>
        <dd class="first_dd">
          <input id="satisfaction_03_01" type="radio" name="satisfaction03" value="3" v-model="answer04">
          <label class="satisfaction_03_01" for="satisfaction_03_01"><span>좋아짐</span>좋아짐</label>
        </dd>
        <dd>
          <input id="satisfaction_03_02" type="radio" name="satisfaction03" value="2" v-model="answer04">
          <label class="satisfaction_03_02" for="satisfaction_03_02"><span>비슷함</span>비슷함</label>
        </dd>
        <dd class="mr50">
          <input id="satisfaction_03_03" type="radio" name="satisfaction03" value="1" v-model="answer04">
          <label class="satisfaction_03_03" for="satisfaction_03_03"><span>나빠짐</span>나빠짐</label>
        </dd>
        <dd>
          <input id="satisfaction_03_04" type="radio" name="satisfaction03" value="4" v-model="answer04">
          <label class="satisfaction_03_04" for="satisfaction_03_04"><span>응대경험없음</span>응대경험없음</label>
        </dd>
      </dl>
      <div class="textarea_st">

        <textarea style="resize:none;"
                  :placeholder="'이용 중 불편했던 사항이나 개선 의견을 적어주세요. \n의견을 주신 분 중 추첨을 통해 소정의 상품을 드립니다. \n(ex. 입력란이 작아요. 입고 조회가 느려요.)'"
                  v-model="opinion01"></textarea>

        <span v-if="opinion01.length>500" style="color: red;font-size: 24px; line-height: 26px; letter-spacing: -1.0px; text-align: left; display: block; padding: 10px 24px 0px 0px;">
          500자 이하로 입력해주세요.</span>
      </div>
    </div>
    <div class="satisfaction_footer">
      <p>응답해 주셔서 감사합니다.<br>코오롱베니트는 더 나은 서비스 제공을 위해 항상<br>최선을 다하겠습니다.</p>
      <br>
      <a id="sendSatisfactionButton" class="evaluation_btn" @click="sendSatisfaction" style="background-color: #ccc;">평가보내기</a>
    </div>
  </div>
</template>

<style  scoped>

@import "../assets/css/kolon_mobil_web_style.css";
  textarea:placeholder-shown {
    overflow: visible;
  }
</style>

<script>
import axios from "axios"
import Util from "@/util/Util";

export default {
  name: 'Satisfaction',
  data(){
    return {
      researchId: '', // IKEN ID
      researchNum: '', // researchNum => 만족도 조사 일자 식별자.
      systemCd: '', // 시스템코드 1(IKEN APP), 2(메일 앱), 3(임직원조회 앱), 4(통합결재 앱), 5(그룹메신저 앱), 6(OneHR 앱)
      systemNm: '', // 시스템코드 1(IKEN APP), 2(메일 앱), 3(임직원조회 앱), 4(통합결재 앱), 5(그룹메신저 앱), 6(OneHR 앱)
      answer01: '', // 시스템과 서비스는 좋아졌는가? 1(나빠짐), 2(비슷함), 3(좋아짐)
      answer02: '', // 시스템 오류 빈도 1(늘어남), 2(비슷함), 3(줄어듬)
      answer03: '', // 시스템 속도 1(느려짐), 2(비슷함), 3(빨라짐)
      answer04: '', // 서비스 담당자 응대 1(나빠짐), 2(비슷함), 3(좋아짐), 4(모르겠음)
      opinion01: '', // 의견
      opinion01OverSize: false, //의견입력란 500자 이상/이하
      sendSatisfactionCnt: 0,
      researchPeriod: '' //상반기 만족도조사 : 지난해 / 하반기 만족도조사 : 상반기
    }
  },
  watch: {
    answer01: function (newAnswer) {
      this.checkValidityAndChangeColor();
    },
    answer02: function (newAnswer) {
      this.checkValidityAndChangeColor();
    },
    answer03: function (newAnswer) {
      this.checkValidityAndChangeColor();
    },
    answer04: function (newAnswer) {
      this.checkValidityAndChangeColor();
    },
    opinion01: function(){
      if(this.opinion01.length>500){
        this.opinion01OverSize = true;
      }else{
        this.opinion01OverSize = false;
      }
      this.checkValidityAndChangeColor();
    }
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      const query = this.$route.query

      this.researchId = query.researchId
      this.systemCd = query.systemCd
      this.researchNum = query.researchNum
      
      if(this.systemCd == '1'){
        this.systemNm = 'IKEN APP'
      }else if(this.systemCd == '2'){
        this.systemNm = '메일 앱'
      }else if(this.systemCd == '3'){
        this.systemNm = '임직원조회 앱'
      }else if(this.systemCd == '4'){
        this.systemNm = '통합결재 앱' // 통합결재
      }else if(this.systemCd == '5'){
        this.systemNm = '그룹메신저 앱'
      }else if(this.systemCd == '6'){
        this.systemNm = 'OneHR 앱'
      }
      //22.11.11
      //상반기 만족도조사인 경우 단어 : 지난해
      //하반기 만족도조사인 경우 단어 : 상반기
      var today = new Date();
      if(today.getMonth()<=8){
        this.researchPeriod='지난해'
      }else{
        this.researchPeriod='상반기'
      }
    },
    sendSatisfaction(){

      if(!this.isValidated()) {
        this.toDisableButtonColor();
        return;
      }
      //의견입력란 500자 초과일 경우 평가보내기 불가능
      if(this.opinion01OverSize){
        return;
      }

      // 버튼 중복 클릭 방지.
      if(this.sendSatisfactionCnt > 0){
        return;
      }
      this.sendSatisfactionCnt++;
      this.toDisableButtonColor();


      var config = {
        method: "post",
        url: process.env.COMN_URL + "rest",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          "methodName": "insertSatisfaction",
          "methodParam": {
            "researchId": this.researchId,
            "researchNum": this.researchNum,
            "systemCd": this.systemCd,
            "answer01": this.answer01,
            "answer02": this.answer02,
            "answer03": this.answer03,
            "answer04": this.answer04,
            "opinion01": this.opinion01
          }
        }
      }

      axios(config)
        .then(res => {
          if(res.data.code === 'OK' && res.data.data.errCode === 'S'){
            // alert(res.data.data.errMsg)
            this.closeSurvey();
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    closeSurvey() {
      var message = {"methodName":"surveyConfirm", "methodParam":"true"};

      if (Util.isIOS()) {
        window.webkit.messageHandlers.web_action.postMessage(message);
      } else if ( Util.isAndroid()) {
        window.web_action.postMessage(JSON.stringify(message));
      }
    },
    isValidated() {
      // 유효성 체크
      if(!this.researchId || this.researchId.trim().length === 0
          || !this.systemCd || this.systemCd.trim().length === 0
          || !this.researchNum || this.researchNum.trim().length === 0
          || !this.answer01 || this.answer01.trim().length === 0
          || !this.answer02 || this.answer02.trim().length === 0
          || !this.answer03 || this.answer03.trim().length === 0
          || !this.answer04 || this.answer04.trim().length === 0
      ) return false;

      //의견입력 500자 초과일 경우 false
      if(this.opinion01OverSize) return false;

      return true;
    },
    checkValidityAndChangeColor(){
      if(this.isValidated()) {
        this.toAbleButtonColor();
      }else {
        this.toDisableButtonColor();
      }
    },
    toDisableButtonColor() {
      var saveBtn = document.querySelector("#sendSatisfactionButton");
      saveBtn.style.backgroundColor = "#ccc";
    },
    toAbleButtonColor() {
      document.querySelector("#sendSatisfactionButton").style.backgroundColor = "#3a6af6";
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Satisfaction.vue